import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=a2c0e4b8"
import script from "./Hint.vue?vue&type=script&lang=js"
export * from "./Hint.vue?vue&type=script&lang=js"
import style0 from "./Hint.vue?vue&type=style&index=0&id=a2c0e4b8&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports